var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isLink || _vm.disabled)?_c('span',{class:_vm.theme},[_vm._t("default")],2):_c('a',{class:_vm.theme,attrs:{"href":_vm.href}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }